function composeMutationKey(schema, parameters) {
    return parameters === undefined ? [
        {
            url: schema.url,
            method: schema.method
        },
        {}
    ] : [
        {
            url: schema.url,
            method: schema.method
        },
        omitMutationPayload(parameters)
    ];
}
function omitMutationPayload(params) {
    if (!params || typeof params !== 'object') throw new Error('`params` must be object');
    if ('body' in params || 'requestBody' in params) {
        const { body: _, requestBody: __, ...paramsRest } = params;
        return paramsRest;
    }
    return params;
}

export { composeMutationKey, omitMutationPayload };
//# sourceMappingURL=composeMutationKey.js.map
